import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import SpecialPricing from './SpecialPricing.js';
import Pricing from './Pricing';
import CompositionAdd from './CompositionAdd.js';


const AddCaseMaterialorAlloy = () => {
  const [isLotRequired, setIsLotRequired] = useState(false);
  const [allowNoteForLot, setAllowNoteForLot] = useState(false);
  const [isSerialRequired, setIsSerialRequired] = useState(false);
  const [allowNoteForSerial, setAllowNoteForSerial] = useState(false);
  const [classification, setClassification] = useState('');
  const [allSpecial, setAllSpecial] = useState([]);
  const [value, setValue] = useState('');
  const [pricingData, setPricingData] = useState({});
  const [compositionData, setCompositionData] = useState([]);



  const handleDataUpdate = (data) => {

    setPricingData(data);
  };

  // composition
  const handleCompositionUpdate = (newData) => {
    setCompositionData(newData);
    // setCompositionData((prevData) => [...prevData, newData]);

  };


  const handleRowsUpdate = (rows) => {

    setAllSpecial(rows);
  };

  
  const handleLotRequiredChange = (e) => {
    setIsLotRequired(e.target.checked);
    if (!e.target.checked) setAllowNoteForLot(false);
  };

  const handleSerialRequiredChange = (e) => {
    setIsSerialRequired(e.target.checked);
    if (!e.target.checked) setAllowNoteForSerial(false);
  };

  const handleClassificationChange = (e) => {
    setClassification(e.target.value);
  };

  const handleValueChange = (e) => {
    setValue(e.target.value);
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    // Add your form submission logic here


    const inputData = {
      valueName: value,
      isLotRequired,
      allowNoteForLot,
      isSerialRequired,
      allowNoteForSerial,
      classification,
      pricing:pricingData,
      specialPricing: allSpecial,
      composition:compositionData,
    }



    try {
      const response = await fetch('https://hms.backend.hiragroupcloud.com/api/add-case-material', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(inputData),
      });
  
      if (response.ok) {
        const data = await response.json();
        
        // navigate(-1);
        // Reset form fields if necessary
      } else {
        console.error('Error submitting form:', response.statusText);
      }
    } catch (error) {
      console.error('Network error:', error);
    }

  };

  const boldStyle = {
    fontWeight: 'bold',
  };

  return (
    <>

              <div style={{width:"1600px"}}>
                <h2 >
                  Add Case Material or Alloy
                  </h2>
                <h3 style={{color:"#004aad"}}>
                  Details
                </h3>
                
                <form className="p-4 "   onSubmit={handleSubmit}>
                  <div style={{borderTop:"2px solid #004aad",backgroundColor:"#f4f4f4",padding:'10px'}}>
                  <div className="mb-3">
                    <label className="form-label" 
                    style={boldStyle}>
                      Value Name *
                      </label>
                    <input type="text" 
                    className="form-control"
                     placeholder="Enter Value Name" 
                     onChange={handleValueChange} 
                     value={value} />
                  </div>
                  <div className="mb-3" 
                  style={{ display: 'flex', alignItems: 'center' }}>
                    <label className="form-label" 
                    style={boldStyle}>
                      Lot #
                    </label>
                    <div className="form-check" 
                    style={{ marginLeft: ' 12%' }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={isLotRequired}
                        onChange={handleLotRequiredChange}
                      />
                      <label 
                      className="form-check-label">
                        Is Required
                        </label>
                    </div>
                    <div className="form-check" 
                    style={{ marginLeft: '10px' }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={allowNoteForLot}
                        onChange={(e) => setAllowNoteForLot(e.target.checked)}
                        disabled={!isLotRequired}
                      />
                      <label className="form-check-label">Allow Note</label>
                    </div>
                  </div>
                  <div className="mb-3" style={{ display: 'flex', alignItems: 'center' }}>
                    <label className="form-label" style={boldStyle}>Serial #</label>
                    <div className="form-check" style={{ marginLeft: ' 10%' }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={isSerialRequired}
                        onChange={handleSerialRequiredChange}
                      />
                      <label className="form-check-label">Is Required</label>
                    </div>
                    <div className="form-check" style={{ marginLeft: '10px' }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={allowNoteForSerial}
                        onChange={(e) => setAllowNoteForSerial(e.target.checked)}
                        disabled={!isSerialRequired}
                      />
                      <label className="form-check-label">Allow Note</label>
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label" style={boldStyle}>Classification *</label>
                    <select className="form-select" value={classification} onChange={handleClassificationChange}>
                      <option value="">Select Classification</option>
                      <option value="ABC">ABC</option>
                      <option value="A">A</option>
                      <option value="B">B</option>
                    </select>
                  </div>
                  </div>
                  <Pricing onDataUpdate={handleDataUpdate} />
                <SpecialPricing onRowsUpdate={handleRowsUpdate} />
                <CompositionAdd onAdd={handleCompositionUpdate} />
                  <button className='btn btn-primary mt-4' style={{backgroundColor:"#004aad", borderColor:"#004aad"}}>Save</button>
                </form>
                </div>
              
    </>
  );
};

export default AddCaseMaterialorAlloy;
